import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

// FIXME: To remove ThemeColors import
import ThemeColors from 'styles/themes/wikifactory/styles/colors';

import { TextField } from 'libs/forms/views/fieldTypes/text';
import { TextAreaField } from 'libs/forms/views/fieldTypes/textArea';
import { FormWrapper, FormWrapperDiv, Label } from 'libs/forms/styles';

import { FormPage } from 'legacyComponents/pages/formPage';
import { Center } from 'legacyComponents/styled/lib';
import Button from 'components/Button';

import Header from 'apps/components/header/header';
import { clientStore } from 'apps/client/app';
import { FourOhFour } from 'apps/fourOhFour/index';

import { InvitationsAppManager } from 'apps/profile/invitations/appManager';
import { Invitation } from 'apps/group/views/invitation';
import { SectionTitle } from 'apps/group/styles';

@withNamespaces()
@observer
export class InvitationsPage extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = new InvitationsAppManager(null, this);
  }

  render() {
    const { signedInProfile } = clientStore;
    if (
      !signedInProfile ||
      clientStore.routerStore.params.get('profile') !== signedInProfile.username
    ) {
      return <FourOhFour />;
    }
    const remainingInvites = clientStore.signedInProfile.invitesLeft;
    const { sentInvites } = this.appManager;

    let form = this.appManager.sendInvites;
    let fieldStore = form.fieldStores.get('invite');
    let FieldComponent = <TextField fieldStore={fieldStore} />;
    let formHandler = this.appManager.SendInvites;
    if (remainingInvites === 0) {
      form = this.appManager.requestInvites;
      fieldStore = form.fieldStores.get('msg');
      FieldComponent = <TextAreaField fieldStore={fieldStore} />;
      formHandler = this.appManager.RequestInvites;
    }
    const {
      conf: { formTitle },
    } = form;

    const FormView =
      sentInvites.apps[0] &&
      sentInvites.apps[0].moreInvitesRequested &&
      remainingInvites === 0 ? (
        <FormWrapperDiv>
          <p
            style={{
              marginBottom: '20px',
              marginTop: '0px',
              lineHeight: '1.5',
              color: ThemeColors.greyDarker,
            }}
          >
            <Trans>
              Great to see you&apos;re enjoying Wikifactory and want to invite
              even more friends! We&apos;re just reviewing your application and
              will be in touch via email 😁
            </Trans>
          </p>
        </FormWrapperDiv>
      ) : (
        <FormWrapper posting={form.posting}>
          <Label>
            <Trans>{fieldStore.conf.label}</Trans>
          </Label>
          {FieldComponent}
          <Center>
            <Button
              text='Send'
              onClick={() => formHandler()}
              style={{ marginTop: '20px' }}
            />
          </Center>
        </FormWrapper>
      );

    const invitesList = [];
    if (sentInvites.length !== 0) {
      sentInvites.forEach(inv => {
        invitesList.push(<Invitation invitation={inv} key={inv.id} />);
      });
    }

    return (
      <main>
        <Header />
        <FormPage
          title={<Trans>You have {{ remainingInvites }} invites left.</Trans>}
          formTitle={formTitle}
          noBackButton
        >
          {FormView}
          {invitesList.length !== 0 ? (
            <div>
              <SectionTitle>
                <Trans>Sent invitations</Trans>:
              </SectionTitle>
              {invitesList}
            </div>
          ) : (
            ''
          )}
        </FormPage>
      </main>
    );
  }
}

InvitationsPage.propTypes = {
  profile: PropTypes.object,
  loading: PropTypes.bool,
};
